export default __webpack_public_path__ + "static/media/default.bb12ade006cdd01c95f9808d08785068.png";